var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi-light:plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 4C7.58175 4 4 7.58175 4 12C4 16.4185 7.58175 20 12 20C16.4185 20 20 16.4185 20 12C20 7.58175 16.4185 4 12 4ZM12 19.0157C8.14025 19.0157 5 15.8597 5 12C5 8.14022 8.14025 4.99997 12 4.99997C15.8597 4.99997 19 8.14023 19 12C19 15.8597 15.8597 19.0157 12 19.0157ZM15.5 11.5H12.5V8.5C12.5 8.224 12.276 8 12 8C11.724 8 11.5 8.224 11.5 8.5V11.5H8.5C8.224 11.5 8 11.724 8 12C8 12.276 8.224 12.5 8.5 12.5H11.5V15.5C11.5 15.776 11.724 16 12 16C12.276 16 12.5 15.776 12.5 15.5V12.5H15.5C15.776 12.5 16 12.276 16 12C16 11.724 15.776 11.5 15.5 11.5Z",
    fill: "#345BE6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCross);
export default __webpack_public_path__ + "static/media/add_cross.4a09e59ba93d146ce4b4a19e1db1b34c.svg";
export { ForwardRef as ReactComponent };